import useStyles from "./styles/comparison";
import { comparisonData } from "../../static/new-landing-page/new-landing-data";
import { withTranslation } from "../../i18n";
import { Hidden } from "@material-ui/core";
import { IMAGE_STATIC } from "../../shared/constants";

const Comparison = ({ t, i18n }) => {
    const language = i18n.language;
    const classes = useStyles();
    const data = comparisonData[language] || comparisonData.en;

    const desktopImage = language === "en"
        ? IMAGE_STATIC.table_comparision_black.desktop_en
        : IMAGE_STATIC.table_comparision_black.desktop_id;
    const mobileImage = language === "en"
        ? IMAGE_STATIC.table_comparision_black.mobile_en
        : IMAGE_STATIC.table_comparision_black.mobile_id;

    function renderTitle() {
        // if (language === "id") {
        //     return (
        //         <span className={classes.title}>Why We Are Better <Hidden smUp><br /></Hidden> Than Others</span>
        //     );
        // }
        return (
            <div className={classes.titleContainer}>
                <h2 className={classes.title}>{data.title}</h2>
                <span className={classes.description}>{data.description}</span>
            </div>
        );
    }

    return (
        <div className={classes.root}>
            <div className={classes.container}>
                {renderTitle()}
                <div className={classes.imageContainer}>
                    <Hidden smDown>
                        <img
                            src={desktopImage}
                            alt="comparison"
                            loading="lazy"
                            className={classes.desktopImage}
                            width={1481}
                            height={551}
                        />
                    </Hidden>
                    <Hidden mdUp>
                        <img
                            src={mobileImage}
                            alt="comparison"
                            loading="lazy"
                            className={classes.mobileImage}
                            width={1328}
                            height={1090}
                        />
                    </Hidden>
                </div>
            </div>
        </div>
    );
};

export default withTranslation(["myfitsociety"])(Comparison);

